var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"nav-item",attrs:{"role":"presentation"}},[_c('a',{staticClass:"nav-link",class:{ active: _vm.active },attrs:{"role":"tab"},on:{"click":function($event){return _setup.emit('click', $event)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }